import { createSlice } from '@reduxjs/toolkit';
import { getMailboxesApi } from '../server/mailbox';

const initialMailboxState = {
    mailboxes: [],
    activeMailbox: null
}

const mailboxSlice = createSlice({
    name: 'mailbox',
    initialState: initialMailboxState,
    reducers: {
        updateMailboxes (state, actions) {
            state.mailboxes = actions.payload;
        },
        updateActiveMailbox (state, actions) {
            state.activeMailbox = actions.payload;
        }
    }
})

export const mailboxActions = mailboxSlice.actions;
export default mailboxSlice;

export const fetchMailboxes = () => {
    return async (dispatch) => {
        try {
            const res = await getMailboxesApi();
            dispatch(mailboxActions.updateMailboxes(res.data ? res.data : []));
        } catch (err) {
            console.log('catch error: ', err);
        }
    }
}